import React from 'react';

import CalculatorForRequest from './CalculatorForRequest';

const RequestCalculatorScreen = (props) => {
    return <CalculatorForRequest formName={props.formName} />;
};

export default RequestCalculatorScreen;
